export function waitForDocumentImages(doc) {
  const images = Array.from(doc.images || []);
  if (!images.length) {
    return Promise.resolve();
  }

  return Promise.all(
    images.map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) {
            resolve();
            return;
          }
          img.addEventListener("load", resolve, { once: true });
          img.addEventListener("error", resolve, { once: true });
        })
    )
  );
}

export function resolveLogoSrc(file) {
  if (!file) {
    return "";
  }

  if (typeof file === "string") {
    return file.startsWith("/")
      ? `${window.location.origin}${file}`
      : file;
  }

  if (typeof file === "object" && (file.url || file._url)) {
    return file.url || file._url;
  }

  return "";
}

export function preparePayrollHeaderForPrint(header) {
  if (!header) {
    return null;
  }

  const resolveLogoList = (logos = []) =>
    logos.map(resolveLogoSrc).filter(Boolean);

  return {
    ...header,
    leftLogo: resolveLogoList(header.leftLogo),
    rightLogo: resolveLogoList(header.rightLogo),
  };
}
